import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiBriefcase, FiMail, FiPhone } = FiIcons;

const Header = ({ language, data }) => {
  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
      className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-stone-200 shadow-sm"
    >
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-br from-amber-600 to-amber-700 rounded-lg flex items-center justify-center">
              <SafeIcon icon={FiBriefcase} className="text-white text-lg" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-stone-800">{data.name}</h1>
              <p className="text-amber-700 text-sm">{data.title}</p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <a
              href={`mailto:${data.email}`}
              className="flex items-center space-x-2 text-stone-600 hover:text-amber-700 transition-colors"
            >
              <SafeIcon icon={FiMail} className="text-lg" />
              <span className="hidden md:inline text-sm">{data.email}</span>
            </a>
            <a
              href={`tel:${data.phone}`}
              className="flex items-center space-x-2 text-stone-600 hover:text-amber-700 transition-colors"
            >
              <SafeIcon icon={FiPhone} className="text-lg" />
              <span className="hidden md:inline text-sm">{data.phone}</span>
            </a>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;